import { Component, OnInit, Input } from "@angular/core";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import _ from "lodash";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { AirbnbAuthRequirementComponent } from "@root/router/component/airbnb-auth-requirement/airbnb-auth-requirement.component";

@Component({
  selector: "host-audit-details",
  templateUrl: "./audit-details.component.html",
  styleUrls: ["./audit-details.component.scss"],
})
export class AuditDetailsComponent implements OnInit {
  @Input() code = null;
  pictureList = [];
  detail;
  constructor(
    private subject: NzModalRef,
    private orderService: OrderV2Service,
    private message: NzMessageService,
    private translateService: TranslateService,
    private modalService: NzModalService
  ) {}

  ngOnInit() {
    this.getDetail();
  }

  getDetail() {
    const params = {
      origin_house_id: this.code,
    };
    this.orderService.getAirbnbFailedDetail(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.detail = this.format(res.data);
      }
    });
  }

  format(data) {
    const house = _.get(data, "house");
    const picture = _.get(house, "cover_picture");
    const url = _.get(picture, "original_url");
    const title = _.get(house, "house_title");
    const record = _.get(data, "record");
    const account_id = _.get(record, "username");
    const fail_reason = _.get(record, "fail");
    _.assign(data, {
      url: url,
      title: title,
      account_id: account_id,
      fail_reason: fail_reason,
    });
    console.log(data);
    return data;
  }

  toFailHouses() {
    this.subject.destroy("openFailList");
  }

  retry() {
    const params = {
      origin_house_id: this.code,
    };
    this.orderService.airbnbRetry(params).subscribe((res) => {
      if (res.error_code === 0) {
        // 该房源正在重新审核
        const successText = this.translateService.syncGet("house.rechecking");
        this.message.success(successText);
      }
    });
  }

  checkRules() {
    this.modalService.create({
      // nzTitle: "爱彼迎官方直连说明",
      nzTitle: this.translateService.syncGet(
        "channel.airbnb_official_direct_connect_info"
      ),
      nzWidth: 706,
      nzContent: AirbnbAuthRequirementComponent,
      nzFooter: null,
    });
  }
}
